import StringValidator from './StringValidator';
import { URL_WITH_ATTRIBUTES_REGEX } from '../../constants/validations';

export class URLWithAttributesValidator extends StringValidator {
  isValid: boolean;
  humanValidated: boolean;

  validate(input: string, humanValidated: boolean = false) {
    super.validate(input);
    this.humanValidated = humanValidated;

    if (input.match(URL_WITH_ATTRIBUTES_REGEX) === null) {
      this.isValid = false;
      this.validationMessage = 'Must be in the form of http(s)://url.com';
    } else {
      this.isValid = true;
    }
  }
}
